import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPacksAction,
  getPackDetailsAction,
  getRequestedPacksAction,
} from "../Action/PackAction";

const initialState = {
  packs: [],
  packDetails: [],
  requests: [],
  isLoading: false,
};

const packSlice = createSlice({
  name: "pack",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPacksAction.pending, (state) => {
        state.packs = [];
        state.isLoading = true;
      })
      .addCase(getAllPacksAction.fulfilled, (state, action) => {
        state.packs = action?.payload?.data;
        state.isLoading = false;
      })
      .addCase(getAllPacksAction.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getRequestedPacksAction.pending, (state) => {
        state.requests = [];
        state.isLoading = true;
      })
      .addCase(getRequestedPacksAction.fulfilled, (state, action) => {
        state.requests = action?.payload?.data;
        state.isLoading = false;
      })
      .addCase(getRequestedPacksAction.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getPackDetailsAction.pending, (state) => {
        state.packDetails = [];
        state.isLoading = true;
      })
      .addCase(getPackDetailsAction.fulfilled, (state, action) => {
        state.packDetails = action?.payload?.data;
        state.isLoading = false;
      })
      .addCase(getPackDetailsAction.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default packSlice.reducer;
